import { ENDPOINT, SIGNATURE_TYPE } from "../../constants/endpoint.js"
import axios from 'axios'
import { vesselsData } from "./vesselData.js";
import { statusData } from "./statusData.js"
import Swal from "sweetalert2";
import router from '../../router'
import moment from "moment";

var configWithToken = {
  headers: {
    "Authorization": `Bearer ${localStorage.getItem('accessToken')}`,
  },
};

const state = {
  vessels: null,
  popupStatus: false,
  statusVessels: null,
  loading: false,
  vessel: null,
  vesselAccessories: null,
  vesselDetail: [],
  registration: null,
  vesselInstall: null
};


const mutations = {
  SET_REGISTRATION: (state, registration) => {
    state.registration = registration
  },
  SET_VESSEL_INSTALL(state, payload) {
    state.vesselInstall = payload
  },
  SET_VESSELS: (state, vessels) => {
    state.vessels = vessels;
  },
  SET_VESSEL: (state, vessel) => {
    state.vessel = vessel
  },
  SET_VESSEL_DETAIL_BY_ID: (state, payload) => {
    state.vesselDetail = payload
  },
  SET_NOTIFICATION(state, payload) {
    state.statusVessels = payload
  },
  SET_CANCEL_REGISTER: (state, id) => {
    const data = vesselsData
    for (const i in data) {
      if (data[i].id == id) {
        data.splice(i, 1);
      }
    }
  },
  SET_CHANGE_STATUS: (state, payload) => {
    const data = vesselsData;
    for (var index in data) {
      if (data[index].id == payload.id) {
        data[index].status = payload.value;
        break;
      }
    }
    state.vessels = data;
  },
  SET_FILTER_REGISTER_BY: (state, payload) => {
    const data = vesselsData;
    const vesselInfo = data.filter((x) => x.registerBy === payload);
    state.vessels = vesselInfo;
  },
  SET_POPUP_STATUS: (state, payload) => {
    state.popupStatus = payload
  },
  LOADING: (state, payload) => {
    state.loading = payload.loading
  },
  SET_VESSEL_ACCESSORIES(state, payload) {
    state.vesselAccessories = payload
  },
  CLEAR_VESSELS: (state, vessel) => {
    state.vessels = []
  },
}
const actions = {
  async setVessels({ commit }, search) {
    commit("LOADING", { loading: true });
    const config = {
      params: {
        ...search,
      },
      headers: {
        "Authorization": `Bearer ${localStorage.getItem('accessToken')}`,
      },
    };
    // console.log('95 >> advanced search', search.type);

    const url = search.type == 'advanced search' ? `${ENDPOINT.GET_VESSELS}/search` : ENDPOINT.GET_VESSELS;
    // console.log("url >>> ", url);
    await axios
      .get(url, config)
      .then(async (response) => {
        const data = response.data;
        // data.map((o)=>{
        //   return o.capacity = _.get(o, "vessel.capacity")
        // })
        await commit("SET_VESSELS", data);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        commit("LOADING", { loading: false });
      });
  },
  async setVesselDetailById({ commit }, vesselId) {
    commit("LOADING", { loading: true });

    const url = `${ENDPOINT.GET_VESSELS}/${vesselId}`;
    await axios
      .get(url)
      .then(async (response) => {
        const data = response.data;
        console.log(data);
        await commit("SET_VESSEL_DETAIL_BY_ID", data);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        commit("LOADING", { loading: false });
      });
  },
  setNotification({ commit }) {
    const data = statusData
    commit('SET_NOTIFICATION', data)
  },
  setCancelRegister: ({ commit }, id) => {
    commit('SET_CANCEL_REGISTER', id)
  },
  async setChangeStatus({ commit }, data) {
    commit("LOADING", { loading: true });
    const config = {
      headers: {
        "Authorization": `Bearer ${localStorage.getItem('accessToken')}`,
      },
    };
    console.log("data ::: ", data);
    console.log("$acl isAdmin ", data.isAdmin);

    //TODO ถ้า admin ยืนยันการลงทะเบียนเรือ ไม่บันทึกลายเซนใครทั้งนั้น!!!!!!!
    if (data.status == "ยืนยันการลงทะเบียนเรือ") {
      if (data.isAdmin) { // admin
        const url = ENDPOINT.UPDATE_STATUS;
        await axios
          .put(url, { ...data }, config)
          .then(async (response) => {
            if (response.data == "รอการพิจารณาของเจ้าหน้าที่") {
              // console.log(response.data);
              Swal.fire({
                icon: "success",
                title: `${response.data}`,
                showConfirmButton: false,
                timer: 2500,
              }).then(() => {
                location.reload();
              });
            } else {
              //notification
              const vessel = response.data.registrationForms[0].vessel
              let notificationReq
              if (data.status == 'ยืนยันการลงทะเบียนเรือ') {
                notificationReq = {
                  userId: response.data.createdBy.id,
                  title: "ลงทะเบียนเรือ (ยืนยันการลงทะเบียนเรือ)",
                  body: `เรือ : ${vessel.name}, ${vessel.zone.name} (${vessel.zone.branch})` //MMSI : ${vessel.mmsi}, 
                }
              }
              this.dispatch("notifications/sendNotificationToApplication", notificationReq)

              Swal.fire({
                icon: "success",
                title: "ยืนยันการลงทะเบียนเรียบร้อยแล้ว",
                showConfirmButton: false,
                timer: 1500,
              }).then(() => {
                location.reload();
              });
            }
          })
          .catch((error) => {
            console.log(error);
            if (error.response.data.statusCode == 500) {  // 409
              Swal.fire({
                icon: "error",
                // title: "MMSI ซ้ำ",
                title: "เกิดข้อผิดพลาด",
                text: "กรุณาลองใหม่อีกครั้ง",
                showConfirmButton: false,
                timer: 1500,
              })
            } else if (error.response.data.statusCode == 413) {
              Swal.fire({
                icon: "error",
                title: "ไฟล์มีขนาดใหญ่เกินไป",
                text: "กรุณาลองใหม่อีกครั้ง",
                showConfirmButton: false,
                timer: 1500,
              })
            }
          })
          .finally(() => {
            commit("LOADING", { loading: false });
          });
      } else {// not admin
        let signatureForm = {
          fileName: data.fileName,
          registrationId: data.registrationId,
          type: SIGNATURE_TYPE.REGISTRATION,
          detail: data.detail
        }
        // signature 
        const createSignatureUrl = ENDPOINT.CREATE_SIGNATURE_BY_FILENAME //TODO ถ้า admin ยืนยันการลงทะเบียนเรือ ต้องดึงลายเซน สรรพสามิต ที่ยังไม่มีใน registrationForm นั้น
        await axios.post(createSignatureUrl, signatureForm, config)
          .then(async (res) => {
            console.log(res);
            const url = ENDPOINT.UPDATE_STATUS;
            await axios
              .put(url, { ...data }, config)
              .then(async (response) => {
                if (response.data == "รอการพิจารณาของเจ้าหน้าที่") {
                  // console.log(response.data);
                  Swal.fire({
                    icon: "success",
                    title: `${response.data}`,
                    showConfirmButton: false,
                    timer: 2500,
                  }).then(() => {
                    location.reload();
                  });
                } else {
                  //notification
                  const vessel = response.data.registrationForms[0].vessel
                  let notificationReq
                  if (data.status == 'ยืนยันการลงทะเบียนเรือ') {
                    notificationReq = {
                      userId: response.data.createdBy.id,
                      title: "ลงทะเบียนเรือ (ยืนยันการลงทะเบียนเรือ)",
                      body: `เรือ : ${vessel.name}, ${vessel.zone.name} (${vessel.zone.branch})` //MMSI : ${vessel.mmsi}, 
                    }
                  }
                  this.dispatch("notifications/sendNotificationToApplication", notificationReq)

                  Swal.fire({
                    icon: "success",
                    title: "ยืนยันการลงทะเบียนเรียบร้อยแล้ว",
                    showConfirmButton: false,
                    timer: 1500,
                  }).then(() => {
                    location.reload();

                    // if (user.signatureName != "" && user.signatureName != null) {
                    // }
                  });
                }
              })
              .catch((error) => {
                console.log(error);
                if (error.response.data.statusCode == 500) {  // 409
                  Swal.fire({
                    icon: "error",
                    title: "MMSI ซ้ำ",
                    showConfirmButton: false,
                    timer: 1500,
                  })
                } else if (error.response.data.statusCode == 413) {
                  Swal.fire({
                    icon: "error",
                    title: "ไฟล์มีขนาดใหญ่เกินไป",
                    text: "กรุณาลองใหม่อีกครั้ง",
                    showConfirmButton: false,
                    timer: 1500,
                  })
                }
              })
              .finally(() => {
                commit("LOADING", { loading: false });
              });
          })
          .catch((error) => {
            console.log(error);
          })
      }
    } else if (data.status == "ยกเลิกการลงทะเบียน") {
      const url = ENDPOINT.UPDATE_STATUS;
      await axios
        .put(url, { ...data }, config)
        .then(async (response) => {
          const vessel = response.data.registrationForms[0].vessel
          Swal.fire({
            icon: "success",
            title: "ยกเลิกการลงทะเบียนเรียบร้อยแล้ว",
            showConfirmButton: false,
            timer: 1500,
          }).then(() => {
            window.location.href = "/admin/vessel";
          });
        })
        .catch((error) => {
          console.log(error);
          if (error.response.data.statusCode == 500) {  // 409
            Swal.fire({
              icon: "error",
              title: "ยกเลิกการลงทะเบียนไม่สำเร็จ",
              showConfirmButton: false,
              timer: 1500,
            })
          }
        })
        .finally(() => {
          commit("LOADING", { loading: false });
        });
    } else {
      let signatureForm = {
        fileName: data.fileName,
        installationsId: data.installations[0].id,
        type: SIGNATURE_TYPE.INSTALLATION
      }
      const createSignatureUrl = ENDPOINT.CREATE_SIGNATURE_BY_FILENAME
      await axios.post(createSignatureUrl, signatureForm, config)
        .then(async (res) => {
          const url = ENDPOINT.UPDATE_STATUS;
          await axios
            .put(url, { ...data }, config)
            .then(async (response) => {
              const vessel = response.data.registrationForms[0].vessel
              //notification
              let notificationReq
              if (data.status == 'ยืนยันการติดตั้งอุปกรณ์') {
                notificationReq = {
                  userId: response.data.createdBy.id,
                  title: "ลงทะเบียนเรือ (ยืนยันการติดตั้งอุปกรณ์)",
                  body: `MMSI : ${vessel.mmsi}, เรือ : ${vessel.name}, ${vessel.zone.name} (${vessel.zone.branch})`
                }
              }
              this.dispatch("notifications/sendNotificationToApplication", notificationReq)
            })
            .catch((error) => {
              console.log(error);
              if (error.response.data.statusCode == 500) {  // 409
                Swal.fire({
                  icon: "error",
                  title: "ยืนยันการติดตั้งอุปกรณ์ไม่สำเร็จ",
                  showConfirmButton: false,
                  timer: 1500,
                })
              }
            })
            .finally(() => {
              commit("LOADING", { loading: false });
            });
        })
        .catch((error) => {
          console.log(error);
        })
    }

  },
  filterRegisterBy({ commit }, payload) {
    commit("SET_FILTER_REGISTER_BY", payload);
  },
  setPopupStatus: ({ commit }) => {
    commit("SET_POPUP_STATUS", false)
  },
  async setVesselById({ commit }, vesselId) {
    commit("LOADING", { loading: true });

    const url = `${ENDPOINT.GET_VESSELS}/${vesselId}`;
    await axios
      .get(url)
      .then(async (response) => {
        const data = response.data;
        // console.log("this is data pppppp", vesselId);
        // console.log("this is data kkkkkk", response);
        await commit("SET_VESSEL", data[0]);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        commit("LOADING", { loading: false });
      });
  },
  async setVesselByIdResigantion({ commit }, vesselId) {
    commit("LOADING", { loading: true });

    const url = `${ENDPOINT.GET_VESSELS}/install/${vesselId}`;
    await axios
      .get(url)
      .then(async (response) => {
        const data = response.data;

        await commit("SET_VESSEL_INSTALL", data[0]);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        commit("LOADING", { loading: false });
      });
  },
  async createRegistration({ commit }, { data, documentNo, documentDate, documentANo, documentADate, documentBNo, documentBDate, vesselImg, documents, receiveOilCode, user, fileName }) {
    const formData = new FormData();
    formData.append("imgNameVessel", vesselImg.imgNameVessel);
    formData.append("imgRightVessel", vesselImg.imgRightVessel);
    formData.append("imgLeftVessel", vesselImg.imgLeftVessel);
    formData.append("imgInstallVessel", vesselImg.imgInstallVessel);
    data.type != 'vessel' && formData.append("imgMeasuringSystem", vesselImg.imgMeasuringSystem);
    formData.append("receiveOilCode", receiveOilCode);
    formData.append("registrationBy", 'ผู้ดูแลระบบ');
    formData.append('vessel', JSON.stringify(data))
    formData.append('documentNo', documentNo)
    formData.append('documentDate', documentDate)
    formData.append('documentANo', documentANo)
    documentADate && formData.append('documentADate', documentADate)
    formData.append('documentBNo', documentBNo)
    documentBDate && formData.append('documentBDate', documentBDate)
    formData.append('user', JSON.stringify(user))

    for (const document of documents) {
      formData.append("documents", document);
    }

    const config = {
      headers: {
        "content-type": "multipart/form-data",
        "Authorization": `Bearer ${localStorage.getItem('accessToken')}`,
      },
    };

    //check registrationNumber
    await axios.get(ENDPOINT.GET_VESSELS_BY_REGISTRATION_NUMBER, {
      params: {
        registrationNumber: data.registrationNumber,
      }
    }).then((res) => {
        console.log("GET_VESSELS_BY_REGISTRATION_NUMBER :: ", res.data);
        if (res.data.length != 0) {
          Swal.fire({
            icon: "error",
            title: "หมายเลขทะเบียนเรือซ้ำ",
            text: "กรุณาตรวจสอบความถูกต้อง",
            showConfirmButton: false,
            timer: 2000,
          })
        }
      })
      .catch(async(error) => {
        console.log(error);

        const mmsi = data.mmsi
        if (mmsi) {
          await this.dispatch('rts/getRtsVesselsByMMSI', { mmsi })
        }

        console.log("vesselByMMSI >>>", this.state.rts.vesselByMMSI.data);
        if (this.state.rts.vesselByMMSI.status != 404) {
          commit("LOADING", { loading: true });
          const url = ENDPOINT.CREATE_REGISTRATION_URL;
          await axios
            .post(url, formData, config)
            .then(async (res) => {
              console.log("this is response createRegistration :>>>>>", res.data.registrationForms[0].vessel);
              if (mmsi) {
                const vesselByMMSI = this.state.rts.vesselByMMSI.data
                const ownerName = user.personType == 'นิติบุคคล'
                  ? user.certificateOperateName
                  : `${user.title}${user.firstName} ${user.lastName}`

                const ownerPhone = user.personType == 'นิติบุคคล'
                  ? user.certificatePhoneNumber
                  : user.phoneNumber

                vesselByMMSI.name = data.name
                vesselByMMSI.call_sign = data.subName
                vesselByMMSI.country_id = "231"
                vesselByMMSI.mid_id = "209"
                // vesselByMMSI.radio_channel = "B"
                vesselByMMSI.ship_class = "B"
                vesselByMMSI.ship_type_id = data.type == "vessel" ? "31" : "81"
                vesselByMMSI.length = data.size
                vesselByMMSI.vendor_id = user.certificateOperateName
                vesselByMMSI.reg_number = data.registrationNumber
                // res.owner_address = "Owner address"
                vesselByMMSI.owner_name = ownerName
                vesselByMMSI.owner_phone = ownerPhone
                // const vesselRts = res.data.registrationForms[0].vessel
                await this.dispatch("rts/updateVesselRts", vesselByMMSI)
              }

              if (res.data.registrationForms[0].registrationBy == "ผู้ดูแลระบบ") {
                Swal.fire({
                  icon: "success",
                  title: "บันทึกเรียบร้อยแล้ว",
                  showConfirmButton: false,
                  timer: 1500,
                }).then(() => {
                  window.location.href = "/admin/vessel";
                });
              } else {
                let signatureForm = {
                  fileName: fileName,
                  registrationId: res.data.id,
                  type: SIGNATURE_TYPE.REGISTRATION
                }

                const config = {
                  headers: {
                    // "content-type": "multipart/form-data",
                    "Authorization": `Bearer ${localStorage.getItem('accessToken')}`,
                  },
                };

                const createSignatureUrl = ENDPOINT.CREATE_SIGNATURE_BY_FILENAME
                await axios.post(createSignatureUrl, signatureForm, config)
                  .then((res) => {
                    Swal.fire({
                      icon: "success",
                      title: "บันทึกเรียบร้อยแล้ว",
                      showConfirmButton: false,
                      timer: 1500,
                    }).then(() => {
                      window.location.href = "/admin/vessel";
                    });
                  })
                  .catch((error) => {
                    console.log(error);
                  })
              }
            })
            .catch((error) => {
              console.log(error);
              // commit("ERROR_VESSEL_TRIP", { error: e });
              if (error.response.data.statusCode == 409) {  // 409
                Swal.fire({
                  icon: "error",
                  title: "ข้อมูลซ้ำ",
                  text: "กรุณาตรวจสอบความถูกต้องของ MMSI หรือ หมายเลขทะเบียนเรือ",
                  showConfirmButton: false,
                  timer: 2000,
                })
              } else if (error.response.data.statusCode == 413) {
                Swal.fire({
                  icon: "error",
                  title: "ไฟล์มีขนาดใหญ่เกินไป",
                  text: "กรุณาลองใหม่อีกครั้ง",
                  showConfirmButton: false,
                  timer: 2000,
                })
              } else if (error.response.data.statusCode == 500) {
                Swal.fire({
                  icon: "error",
                  title: "เกิดข้อผิดพลาด",
                  text: "กรุณาตรวจสอบความถูกต้อง",
                  showConfirmButton: false,
                  timer: 2000,
                });
              }
            })
            .finally(() => {
              commit("LOADING", { loading: false });
            });
        } else {
          console.log(this.state.rts.vesselByMMSI.status);
        }
      })



  },
  async getVesselAccessories({ commit }) {
    const url = ENDPOINT.GET_VESSEL_ACCESSORIES
    await axios.get(url, null, configWithToken)
      .then(response => {
        this.dispatch("notifications/getNotificationForNavbar")
        console.log("this is response :", response.data);
        commit("SET_VESSEL_ACCESSORIES", response.data)
      })
      .catch(error => console.log(error))
  },
  async setVesselAccessories({ commit }, payload) {
    const url = ENDPOINT.CREATE_VESSEL_ACCESSORIES
    const config = {
      headers: {
        // "content-type": "multipart/form-data",
        "Authorization": `Bearer ${localStorage.getItem('accessToken')}`,
      },
    };
    // console.log(payload);
    await axios.post(url, payload, config)
      .then(response => {
        console.log(response.data);
        const vessel = response.data.vessel
        const receiveDate = response.data.accessoriesReceives[0].receiveDate

        const notificationReq = {
          userId: response.data.registration.createdBy.id,
          title: `ลงทะเบียนเรือ (แจ้งรับอุปกรณ์วันที่ ${moment(receiveDate).add(543, "year").format("DD/MM/YYYY")})`,
          body: `MMSI : ${vessel.mmsi}, เรือ : ${vessel.name}, ${vessel.zone.name} (${vessel.zone.branch})`
        }
        this.dispatch("notifications/sendNotificationToApplication", notificationReq)
        this.dispatch("notifications/getNotificationForNavbar")
      })
      .catch(error => {
        console.log(error);
      })
  },
  async updateVessel({ commit }, { data, user }) {
    console.log("updateVessel ", data);
    console.log("updateVessel user ", user);
    const config = {
      headers: {
        "content-type": "multipart/form-data",
        "Authorization": `Bearer ${localStorage.getItem('accessToken')}`,
      },
    };

    console.log("data.mmsi :::::::::: ", data.mmsi);
    if (data.mmsi) {
      await this.dispatch('rts/getRtsVesselsByMMSI', { mmsi: data.mmsi })
    }

    console.log("vesselByMMSI >>>", this.state.rts.vesselByMMSI);
    if (this.state.rts.vesselByMMSI.status != 404) {
      commit("LOADING", { loading: true });
      await axios.put(`${ENDPOINT.UPDATE_VESSEL}`, data)
        .then(async (res) => {
          console.log('response >>> ', res.data);
          console.log(this.state.rts.vesselByMMSI.data);

          if (res.data.mmsi && this.state.rts.vesselByMMSI.data) {
            const vesselByMMSI = this.state.rts.vesselByMMSI.data
            const ownerName = user.personType == 'นิติบุคคล'
              ? user.certificateOperateName
              : `${user.title}${user.firstName} ${user.lastName}`
            const ownerPhone = user.personType == 'นิติบุคคล'
              ? user.certificatePhoneNumber
              : user.phoneNumber
            vesselByMMSI.name = data.name
            vesselByMMSI.call_sign = data.subName
            vesselByMMSI.country_id = "231"
            vesselByMMSI.mid_id = "209"
            // vesselByMMSI.radio_channel = "B"
            vesselByMMSI.ship_class = "B"
            vesselByMMSI.ship_type_id = data.type == "vessel" ? "31" : "81"
            vesselByMMSI.length = data.size
            vesselByMMSI.vendor_id = user.certificateOperateName
            vesselByMMSI.reg_number = data.registrationNumber
            vesselByMMSI.owner_name = ownerName
            vesselByMMSI.owner_phone = ownerPhone
            await this.dispatch("rts/updateVesselRts", vesselByMMSI)
          }
          // update image
          const images = data.vesselImg;
          const url = ENDPOINT.UPDATE_VESSEL_IMAGE;

          if (images.imgNameVessel) {
            const formData = new FormData();
            formData.append("id", data.id);
            formData.append("files", images.imgNameVessel);
            formData.append("imageType", "imgNameVessel");
            axios.put(url, formData, config);
          }
          if (images.imgRightVessel) {
            const formData = new FormData();
            formData.append("id", data.id);
            formData.append("files", images.imgRightVessel);
            formData.append("imageType", "imgRightVessel");
            axios.put(url, formData, config);
          }
          if (images.imgLeftVessel) {
            const formData = new FormData();
            formData.append("id", data.id);
            formData.append("files", images.imgLeftVessel);
            formData.append("imageType", "imgLeftVessel");
            axios.put(url, formData, config);
          }
          if (images.imgInstallVessel) {
            const formData = new FormData();
            formData.append("id", data.id);
            formData.append("files", images.imgInstallVessel);
            formData.append("imageType", "imgInstallVessel");
            axios.put(url, formData, config);
          }
          if (images.imgMeasuringSystem) {
            const formData = new FormData();
            formData.append("id", data.id);
            formData.append("files", images.imgMeasuringSystem);
            formData.append("imageType", "imgMeasuringSystem");
            axios.put(url, formData, config);
          }

          Swal.fire({
            target: document.getElementById("popup-edit-vessel"),
            icon: "success",
            title: "บันทึกเรียบร้อยแล้ว",
            showConfirmButton: false,
            timer: 1500,
          }).then(() => {
            router.push(`/vessel/detail/${data.registrationFormId}`)
          });
        })
        .catch(error => {
          console.log(" error.response ", error.response);
          // commit("ERROR", error.response.data.statusCode);
          const statusCode = error.response.data.statusCode;
          if (statusCode == 409) {
            Swal.fire({
              target: document.getElementById("popup-edit-vessel"),
              icon: "error",
              title: "หมายเลข MMSI ซ้ำ",
              text: "กรุณากรอกข้อมูลให้ถูกต้อง",
              showConfirmButton: false,
              timer: 2000,
            });
          } else {
            Swal.fire({
              target: document.getElementById("popup-edit-vessel"),
              icon: "warning",
              title: "เกิดข้อผิดพลาด",
              text: "กรุณากรอกข้อมูลให้ถูกต้อง",
              showConfirmButton: false,
              timer: 2000,
            });
          }
        })
    }

  },
  async getNumberOfRegistration({ commit }) {
    const url = `${ENDPOINT.GET_NUMBER_OF_REGISTRATION}`;
    console.log("url ____ ", url);
    await axios
      .get(url, null, configWithToken)
      .then(async (response) => {
        const data = response.data;
        // console.log("data ", data);
        await commit("SET_REGISTRATION", data);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
      });

  },
  async addMMSI({ commit }, { mmsi, vesselId, vesselRts }) {
    const data = {
      vesselId,
      mmsi
    }
    commit("LOADING", { loading: true });
    await axios.post(`${ENDPOINT.CREATE_MMSI}`, data)
      .then(async (res) => {
        //TODO updateVesselRts by mmsi =>  
        await this.dispatch("rts/updateVesselRts", vesselRts)
        Swal.fire({
          icon: "success",
          title: "บันทึกเรียบร้อยแล้ว",
          showConfirmButton: false,
          timer: 1500,
        })
      })
      .catch(error => {
        const statusCode = error.response.data.statusCode;
        if (statusCode == 409) {
          Swal.fire({
            icon: "error",
            title: "MMSI ซ้ำ",
            text: "กรุณากรอกข้อมูลให้ถูกต้อง",
            showConfirmButton: false,
            timer: 2000,
          });
        } else {
          Swal.fire({
            icon: "warning",
            title: "เกิดข้อผิดพลาด",
            text: "กรุณาตรวจสอบความถูกต้อง",
            showConfirmButton: false,
            timer: 2000,
          });
        }
      })
  },
  async deleteDocument({ commit }, id) {
    console.log("delete ", id);
    // commit("LOADING", { loading: true });
    await axios.delete(`${ENDPOINT.DOCUMENT}/${id}`)
      .then((res) => {
        Swal.fire({
          icon: "success",
          title: "ลบเอกสารเรียบร้อยแล้ว",
          showConfirmButton: false,
          timer: 1500,
        }).then(() => {
        });
      })
      .catch(error => {
        const statusCode = error.response.data.statusCode;
        Swal.fire({
          icon: "warning",
          title: "เกิดข้อผิดพลาด",
          text: "กรุณาตรวจสอบความถูกต้อง",
          showConfirmButton: false,
          timer: 2000,
        });
      })
  },
  async addDocuments({ commit }, { registrationFormId, files }) {
    console.log(registrationFormId, files);

    const formData = new FormData();
    for (const file of files) {
      formData.append("files", file);
    }

    await axios.post(`${ENDPOINT.DOCUMENT}/${registrationFormId}`, formData)
      .then((res) => {

      })
      .catch(error => {
        const statusCode = error.response.data.statusCode;
        Swal.fire({
          icon: "warning",
          title: "เกิดข้อผิดพลาด ไม่สามารถอัปโหลดไฟล์ได้",
          text: "กรุณาตรวจสอบความถูกต้อง",
          showConfirmButton: false,
          timer: 2000,
        });
      })
  },
  async clearVessels({ commit }) {
    commit('CLEAR_VESSELS', null)
  }


}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
